import { ChargeDetails } from 'src/dto/response/fetchBookingBreakdown';
import { isValidArray } from 'src/Library/Helper';
import { CInvoicingChargeCategoryType, CInvoicingChargeDetailsType } from '../types';
import { CInvoicingChargeCategory } from './CInvoicingChargeCategory';
import { CInvoicingChargeList } from './CInvoicingChargesList';
import { CInvoicingChargeValue } from './CInvoicingChargeValue';
import { CInvoicingPriceWithTax } from './CInvoicingPriceWithTax';

export class CInvoicingChargeDetails implements CInvoicingChargeDetailsType {

  constructor(json: CInvoicingChargeDetailsType) {
    Object.assign(this, json);
  }

  details?: ChargeDetails;

  toInvoicingChargeList = (): CInvoicingChargeList => {
    const charges = this.details ? Object.values(this.details).reduce((acc, cur: CInvoicingChargeCategoryType) => {
      acc.push(...cur.values.map(val => ({
        ...val,
        chargeCategory: cur.name,
      })));
      return acc;
    }, [] as CInvoicingChargeValue[]) : [];
    return new CInvoicingChargeList({
      charges,
    });
  };

  toInvoicingChargeDetailsForPrefilling(): CInvoicingChargeDetails | undefined {
    const sanitisedDetails = this.details ? Object.keys(this.details).reduce((acc, categoryKey) => {
      const categoryValue: CInvoicingChargeCategoryType = this.details?.[categoryKey];
      acc[categoryKey] = {
        ...categoryValue,
        values: categoryValue.values.filter(val => !val.isRemovedCharge),
      };
      return acc;
    }, {} as ChargeDetails) : undefined;
    return new CInvoicingChargeDetails({
      details: sanitisedDetails,
    });
  }
}
